import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrl: './cards.component.scss',
})
export class CardsComponent {
  @Input() title: string;

  @Input() text: string;

  @Input() footer: string;

  // style classes (flex-wrap)
  @Input() headerStyle: string;

  //Backgound Color Value; primary, secondary, success, danger, warning, info, light, dark
  @Input() backgroundColor: string;

  // Border Value: border-0, border-1, border-2, border-3, border-4, border-5 (0: boderless; 5: max width for border)
  // Border Padding Value: pb-0, pb-1, pb-2, pb-3, pb-4, pb-5
  @Input() headerDivider: string;
  @Input() footerDivider: string;

  // Header Color Value: text-white (default value: text-black)
  @Input() whiteHeader: string;

  // Text Color Value: text-white, text-pink, text-yellow...
  @Input() color: string;

  // Text align center value: center
  @Input() center: string;

  @Input() styleBody: string
}
